/* Generated by ai2react v0.102.0 - 2021-09-14 04:14 */
/* ai file: 09-the-latam-chile.ai */

import { makeAi2React } from './src/index'
import img0 from './img/09-the-latam-chile-large.svg'
import img1 from './img/09-the-latam-chile-mobile.svg'

const styles = `
  #g-09-the-latam-chile-box ,
  #g-09-the-latam-chile-box .g-artboard {
    margin:0 auto;
  }
  #g-09-the-latam-chile-box p {
    margin:0;
  }
  #g-09-the-latam-chile-box .g-aiAbs {
    position:absolute;
  }
  #g-09-the-latam-chile-box .g-aiImg {
    position:absolute;
    top:0;
    display:block;
    width:100% !important;
  }
  #g-09-the-latam-chile-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-09-the-latam-chile-box .g-aiPointText p { white-space: nowrap; }
  #g-09-the-latam-chile-large {
    position:relative;
    overflow:hidden;
  }
  #g-09-the-latam-chile-large p {
    font-family:Inter;
    font-weight:400;
    line-height:11px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:9px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-09-the-latam-chile-large .g-pstyle0 {
    font-weight:800;
    line-height:23px;
    height:23px;
    letter-spacing:-0.02em;
    font-size:19px;
  }
  #g-09-the-latam-chile-large .g-pstyle1 {
    font-weight:700;
    height:11px;
    letter-spacing:0em;
  }
  #g-09-the-latam-chile-large .g-pstyle2 {
    font-weight:700;
    line-height:12px;
    height:12px;
    letter-spacing:-0.019em;
    font-size:10px;
    color:rgb(101,54,148);
  }
  #g-09-the-latam-chile-large .g-pstyle3 {
    font-weight:700;
    height:11px;
    letter-spacing:-0.02em;
  }
  #g-09-the-latam-chile-large .g-pstyle4 {
    height:11px;
  }
  #g-09-the-latam-chile-large .g-pstyle5 {
    line-height:10px;
    height:10px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle6 {
    line-height:9px;
    height:9px;
    letter-spacing:0em;
    font-size:8px;
  }
  #g-09-the-latam-chile-large .g-pstyle7 {
    line-height:9px;
    height:9px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-09-the-latam-chile-large .g-pstyle8 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.03em;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle9 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.034em;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle10 {
    height:11px;
    letter-spacing:-0.03em;
  }
  #g-09-the-latam-chile-large .g-pstyle11 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.036em;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle12 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.086em;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle13 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.035em;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-large .g-pstyle14 {
    line-height:12px;
    height:12px;
    font-size:10px;
  }
  #g-09-the-latam-chile-large .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-09-the-latam-chile-large .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-09-the-latam-chile-large .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-09-the-latam-chile-large .g-cstyle3 {
    letter-spacing:-0.03em;
  }
  #g-09-the-latam-chile-large .g-cstyle4 {
    letter-spacing:-0.033em;
  }
  #g-09-the-latam-chile-large .g-cstyle5 {
    letter-spacing:-0.032em;
  }
  #g-09-the-latam-chile-large .g-cstyle6 {
    letter-spacing:-0.11em;
  }
  #g-09-the-latam-chile-large .g-cstyle7 {
    letter-spacing:-0.04em;
  }
  #g-09-the-latam-chile-large .g-cstyle8 {
    letter-spacing:-0.029em;
  }
  #g-09-the-latam-chile-large .g-cstyle9 {
    letter-spacing:-0.05em;
  }
  #g-09-the-latam-chile-large .g-cstyle10 {
    letter-spacing:-0.034em;
  }
  #g-09-the-latam-chile-large .g-cstyle11 {
    letter-spacing:-0.042em;
  }
  #g-09-the-latam-chile-large .g-cstyle12 {
    letter-spacing:-0.043em;
  }
  #g-09-the-latam-chile-large .g-cstyle13 {
    letter-spacing:-0.036em;
  }
  #g-09-the-latam-chile-large .g-cstyle14 {
    letter-spacing:-0.035em;
  }
  #g-09-the-latam-chile-large .g-cstyle15 {
    letter-spacing:-0.116em;
  }
  #g-09-the-latam-chile-large .g-cstyle16 {
    letter-spacing:-0.086em;
  }
  #g-09-the-latam-chile-large .g-cstyle17 {
    letter-spacing:-0.044em;
  }
  #g-09-the-latam-chile-large .g-cstyle18 {
    letter-spacing:-0.039em;
  }
  #g-09-the-latam-chile-large .g-cstyle19 {
    letter-spacing:-0.037em;
  }
  #g-09-the-latam-chile-large .g-cstyle20 {
    letter-spacing:-0.041em;
  }
  #g-09-the-latam-chile-mobile {
    position:relative;
    overflow:hidden;
  }
  #g-09-the-latam-chile-mobile p {
    font-family:Inter;
    font-weight:400;
    line-height:12px;
    height:auto;
    filter:alpha(opacity=100);
    -ms-filter:progid:DXImageTransform.Microsoft.Alpha(Opacity=100);
    opacity:1;
    letter-spacing:-0.029em;
    font-size:10px;
    text-align:left;
    color:rgb(0,0,0);
    text-transform:none;
    padding-bottom:0;
    padding-top:0;
    mix-blend-mode:normal;
    font-style:normal;
    position:static;
  }
  #g-09-the-latam-chile-mobile .g-pstyle0 {
    font-weight:800;
    line-height:23px;
    height:23px;
    letter-spacing:-0.02em;
    font-size:19px;
  }
  #g-09-the-latam-chile-mobile .g-pstyle1 {
    font-weight:700;
    line-height:13px;
    height:13px;
    letter-spacing:-0.019em;
    font-size:11px;
    color:rgb(101,54,148);
  }
  #g-09-the-latam-chile-mobile .g-pstyle2 {
    font-weight:700;
    height:12px;
    letter-spacing:-0.02em;
  }
  #g-09-the-latam-chile-mobile .g-pstyle3 {
    font-weight:700;
    height:12px;
    letter-spacing:0em;
  }
  #g-09-the-latam-chile-mobile .g-pstyle4 {
    height:12px;
    letter-spacing:-0.03em;
  }
  #g-09-the-latam-chile-mobile .g-pstyle5 {
    height:12px;
  }
  #g-09-the-latam-chile-mobile .g-pstyle6 {
    line-height:11px;
    height:11px;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-pstyle7 {
    line-height:10px;
    height:10px;
    letter-spacing:0em;
    font-size:8px;
  }
  #g-09-the-latam-chile-mobile .g-pstyle8 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.036em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-pstyle9 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.03em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-pstyle10 {
    line-height:10px;
    height:10px;
    letter-spacing:-0.019em;
    font-size:8px;
  }
  #g-09-the-latam-chile-mobile .g-pstyle11 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.086em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-pstyle12 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.034em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-pstyle13 {
    line-height:11px;
    height:11px;
    letter-spacing:-0.035em;
    font-size:9px;
    color:rgb(88,89,91);
  }
  #g-09-the-latam-chile-mobile .g-cstyle0 {
    letter-spacing:-0.019em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle1 {
    letter-spacing:0em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle2 {
    letter-spacing:-0.02em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle3 {
    letter-spacing:-0.029em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle4 {
    letter-spacing:-0.033em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle5 {
    letter-spacing:-0.03em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle6 {
    letter-spacing:-0.04em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle7 {
    letter-spacing:-0.05em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle8 {
    letter-spacing:-0.043em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle9 {
    letter-spacing:-0.034em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle10 {
    letter-spacing:-0.116em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle11 {
    letter-spacing:-0.036em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle12 {
    letter-spacing:-0.037em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle13 {
    letter-spacing:-0.039em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle14 {
    letter-spacing:-0.041em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle15 {
    letter-spacing:-0.032em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle16 {
    letter-spacing:-0.11em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle17 {
    letter-spacing:-0.042em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle18 {
    letter-spacing:-0.035em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle19 {
    letter-spacing:-0.086em;
  }
  #g-09-the-latam-chile-mobile .g-cstyle20 {
    letter-spacing:-0.044em;
  }

`

const html = props => `
<div id="g-09-the-latam-chile-box" class="ai2html">


  <!-- Artboard: large -->
  <div id="g-09-the-latam-chile-large" class="g-artboard" style="width:800px; height:573px;" data-aspect-ratio="1.396" data-min-width="800">
<div style=""></div>
    <img id="g-09-the-latam-chile-large-img" class="g-aiImg" alt="" src="${img0}"/>
    <div id="g-ai0-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.3916%;margin-top:-13.4px;left:1.4442%;width:487px;">
      <p class="g-pstyle0"><span class="g-cstyle0">THE</span> LATI<span class="g-cstyle0">N</span> AM<span class="g-cstyle0">E</span>RICA U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai0-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.1979%;margin-top:-6.2px;left:91.9205%;width:57px;">
      <p class="g-pstyle1">Puntaje </p>
    </div>
    <div id="g-ai0-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.3123%;margin-top:-6.9px;left:7.7336%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.3123%;margin-top:-6.9px;left:56.2183%;width:72px;">
      <p class="g-pstyle2"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai0-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.3725%;margin-top:-6.2px;left:3.7997%;width:36px;">
      <p class="g-pstyle3">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.3725%;margin-top:-6.2px;left:52.2924%;width:36px;">
      <p class="g-pstyle3">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.3725%;margin-top:-6.2px;left:38.7325%;width:57px;">
      <p class="g-pstyle1">Puntaje </p>
    </div>
    <div id="g-ai0-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.7686%;margin-top:-6.2px;left:3.3367%;width:41px;">
      <p class="g-pstyle3"><span class="g-cstyle0">N</span>A<span class="g-cstyle1">C</span></p>
    </div>
    <div id="g-ai0-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:8.7686%;margin-top:-6.2px;left:51.8215%;width:41px;">
      <p class="g-pstyle3"><span class="g-cstyle0">N</span>A<span class="g-cstyle1">C</span></p>
    </div>
    <div id="g-ai0-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.3633%;margin-top:-6.6px;left:7.7258%;width:185px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">o</span>nti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">ia</span> <span class="g-cstyle4">U</span>ni<span class="g-cstyle3">ve</span>r<span class="g-cstyle3">sid</span>a<span class="g-cstyle3">d</span> C<span class="g-cstyle4">a</span>tól<span class="g-cstyle3">ica</span> <span class="g-cstyle3">d</span>e Ch<span class="g-cstyle3">i</span>l<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.3633%;margin-top:-6.6px;left:56.2105%;width:110px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span><span class="g-cstyle6">T</span>al<span class="g-cstyle3">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.7424%;margin-top:-5.7px;left:34.9636%;width:42px;">
      <p class="g-pstyle5">9<span class="g-cstyle7">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.7424%;margin-top:-5.7px;left:88.1202%;width:42px;">
      <p class="g-pstyle5">46,<span class="g-cstyle3">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.628%;margin-top:-5.1px;left:4.3259%;width:28px;">
      <p class="g-pstyle6"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai0-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.628%;margin-top:-5.1px;left:52.5358%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.1224%;margin-top:-6.6px;left:7.7258%;width:109px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Ch<span class="g-cstyle3">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.1224%;margin-top:-6.6px;left:56.2105%;width:225px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">C</span><span class="g-cstyle5">a</span>tól<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>e l<span class="g-cstyle3">a</span> S<span class="g-cstyle3">an</span>tísim<span class="g-cstyle3">a</span> C<span class="g-cstyle3">o</span>n<span class="g-cstyle3">ce</span>p<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5016%;margin-top:-5.7px;left:35.0259%;width:40px;">
      <p class="g-pstyle5">8<span class="g-cstyle3">2</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.5016%;margin-top:-5.7px;left:88.1911%;width:41px;">
      <p class="g-pstyle8"><span class="g-cstyle8">4</span>2,<span class="g-cstyle8">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.3872%;margin-top:-5.1px;left:4.3026%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai0-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.3872%;margin-top:-5.1px;left:52.5203%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.0561%;margin-top:-6.6px;left:7.7258%;width:207px;">
      <p class="g-pstyle4">P<span class="g-cstyle3">o</span>nti<span class="g-cstyle3">fi</span>c<span class="g-cstyle3">ia</span> <span class="g-cstyle4">U</span>ni<span class="g-cstyle3">ve</span>r<span class="g-cstyle3">sid</span>a<span class="g-cstyle3">d</span> C<span class="g-cstyle4">a</span>tól<span class="g-cstyle3">ica</span> <span class="g-cstyle3">d</span>e <span class="g-cstyle9">V</span><span class="g-cstyle3">a</span>lpa<span class="g-cstyle3">r</span>a<span class="g-cstyle3">í</span>s<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.0561%;margin-top:-6.6px;left:56.2105%;width:150px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">C</span><span class="g-cstyle5">a</span>tól<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>el No<span class="g-cstyle3">rt</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2608%;margin-top:-5.7px;left:34.9786%;width:42px;">
      <p class="g-pstyle5">6<span class="g-cstyle3">5</span>,8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.2608%;margin-top:-5.7px;left:88.2309%;width:41px;">
      <p class="g-pstyle5">3<span class="g-cstyle10">8</span><span class="g-cstyle11">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1463%;margin-top:-5.1px;left:4.3104%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai0-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.1463%;margin-top:-5.1px;left:52.5513%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8153%;margin-top:-6.6px;left:7.7258%;width:161px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>S<span class="g-cstyle3">a</span>nt<span class="g-cstyle3">i</span>ago d<span class="g-cstyle3">e </span>Ch<span class="g-cstyle3">i</span>l<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.8153%;margin-top:-6.6px;left:56.2105%;width:131px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>L<span class="g-cstyle3">o</span>s Lagos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.0199%;margin-top:-5.7px;left:35.0334%;width:41px;">
      <p class="g-pstyle5">6<span class="g-cstyle3">2</span><span class="g-cstyle12">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.0199%;margin-top:-5.7px;left:88.1685%;width:42px;">
      <p class="g-pstyle5">3<span class="g-cstyle10">8</span><span class="g-cstyle13">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.9055%;margin-top:-5.1px;left:4.287%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai0-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:30.9055%;margin-top:-5.1px;left:52.5203%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5744%;margin-top:-6.6px;left:7.7258%;width:140px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">A</span>ust<span class="g-cstyle3">r</span>al <span class="g-cstyle3">d</span>e Chil<span class="g-cstyle3">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.5744%;margin-top:-6.6px;left:56.2105%;width:130px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>La Se<span class="g-cstyle4">r</span>ena<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.9536%;margin-top:-5.7px;left:34.9786%;width:42px;">
      <p class="g-pstyle5">5<span class="g-cstyle10">8</span><span class="g-cstyle3">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.9536%;margin-top:-5.7px;left:88.1448%;width:42px;">
      <p class="g-pstyle9"><span class="g-cstyle8">3</span>8<span class="g-cstyle14">,</span><span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.8392%;margin-top:-5.1px;left:4.3104%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai0-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:36.8392%;margin-top:-5.1px;left:52.5203%;width:32px;">
      <p class="g-pstyle7"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.3336%;margin-top:-6.6px;left:7.7258%;width:197px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle15">T</span><span class="g-cstyle3">éc</span>n<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> <span class="g-cstyle3">F</span>e<span class="g-cstyle3">d</span>e<span class="g-cstyle3">r</span>i<span class="g-cstyle3">c</span>o <span class="g-cstyle3">S</span>a<span class="g-cstyle3">n</span>ta M<span class="g-cstyle3">a</span>r<span class="g-cstyle3">í</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.3336%;margin-top:-6.6px;left:56.2105%;width:128px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>n<span class="g-cstyle3">d</span><span class="g-cstyle5">r</span><span class="g-cstyle3">é</span>s Bello<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-5.7px;left:34.9947%;width:42px;">
      <p class="g-pstyle5">5<span class="g-cstyle13">4</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.7128%;margin-top:-5.7px;left:85.5064%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle8">3</span>1<span class="g-cstyle14">,</span>0&ndash;<span class="g-cstyle8">3</span><span class="g-cstyle16">7</span><span class="g-cstyle8">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.5983%;margin-top:-5.1px;left:4.2949%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai0-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:42.5983%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.2673%;margin-top:-6.6px;left:7.7258%;width:132px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>L<span class="g-cstyle3">o</span>s A<span class="g-cstyle3">n</span>d<span class="g-cstyle3">es</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.2673%;margin-top:-6.6px;left:56.2105%;width:102px;">
      <p class="g-pstyle10"><span class="g-cstyle5">U</span>n<span class="g-cstyle8">iv</span>e<span class="g-cstyle8">r</span>s<span class="g-cstyle8">i</span>d<span class="g-cstyle8">a</span>d<span class="g-cstyle8"> </span>M<span class="g-cstyle8">ay</span>or<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4719%;margin-top:-5.7px;left:34.9399%;width:42px;">
      <p class="g-pstyle11"><span class="g-cstyle8">5</span>4,<span class="g-cstyle8">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.4719%;margin-top:-5.7px;left:85.5064%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle8">3</span>1<span class="g-cstyle14">,</span>0&ndash;<span class="g-cstyle8">3</span><span class="g-cstyle16">7</span><span class="g-cstyle8">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3575%;margin-top:-5.1px;left:4.3182%;width:28px;">
      <p class="g-pstyle6"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai0-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:48.3575%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.0264%;margin-top:-6.6px;left:7.7258%;width:154px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">A</span>utón<span class="g-cstyle3">o</span>m<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>e <span class="g-cstyle3">Ch</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.0264%;margin-top:-6.6px;left:56.2105%;width:127px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span><span class="g-cstyle6">T</span>a<span class="g-cstyle3">r</span>ap<span class="g-cstyle3">a</span>cá<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.2311%;margin-top:-5.7px;left:34.971%;width:42px;">
      <p class="g-pstyle8"><span class="g-cstyle8">5</span>2<span class="g-cstyle8">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.2311%;margin-top:-5.7px;left:85.5064%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle8">3</span>1<span class="g-cstyle14">,</span>0&ndash;<span class="g-cstyle8">3</span><span class="g-cstyle16">7</span><span class="g-cstyle8">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.1166%;margin-top:-5.1px;left:4.2949%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai0-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:54.1166%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.7856%;margin-top:-6.6px;left:7.7258%;width:138px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>Co<span class="g-cstyle3">n</span>c<span class="g-cstyle3">e</span>p<span class="g-cstyle3">c</span>ió<span class="g-cstyle3">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.7856%;margin-top:-6.6px;left:56.2105%;width:157px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">C</span><span class="g-cstyle5">a</span>tól<span class="g-cstyle3">i</span>c<span class="g-cstyle3">a</span> <span class="g-cstyle3">d</span>e <span class="g-cstyle15">T</span>emu<span class="g-cstyle3">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.9903%;margin-top:-5.7px;left:35.0571%;width:40px;">
      <p class="g-pstyle5">51<span class="g-cstyle13">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.9903%;margin-top:-5.7px;left:85.5064%;width:60px;">
      <p class="g-pstyle8"><span class="g-cstyle8">3</span>1<span class="g-cstyle14">,</span>0&ndash;<span class="g-cstyle8">3</span><span class="g-cstyle16">7</span><span class="g-cstyle8">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.0503%;margin-top:-5.1px;left:4.2949%;width:29px;">
      <p class="g-pstyle6"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai0-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:60.0503%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.5448%;margin-top:-6.6px;left:7.7258%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">D</span>iego P<span class="g-cstyle3">o</span>rt<span class="g-cstyle3">a</span>les<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.5448%;margin-top:-6.6px;left:56.2105%;width:120px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3">l</span> Bí<span class="g-cstyle3">o</span><span class="g-cstyle17">-</span>Bío<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.9239%;margin-top:-5.7px;left:35.0173%;width:41px;">
      <p class="g-pstyle5">51,<span class="g-cstyle3">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.9239%;margin-top:-5.7px;left:85.2711%;width:63px;">
      <p class="g-pstyle5">2<span class="g-cstyle13">4</span><span class="g-cstyle7">,</span>9<span class="g-cstyle3">&ndash;</span>3<span class="g-cstyle18">0</span><span class="g-cstyle3">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.8095%;margin-top:-5.1px;left:4.0283%;width:32px;">
      <p class="g-pstyle7">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.8095%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">24<span class="g-cstyle2">-</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.4785%;margin-top:-6.6px;left:7.7258%;width:136px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span>La <span class="g-cstyle19">F</span><span class="g-cstyle4">r</span>ont<span class="g-cstyle3">e</span>r<span class="g-cstyle3">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.4785%;margin-top:-6.6px;left:56.2105%;width:135px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> S<span class="g-cstyle3">a</span>n Sebasti<span class="g-cstyle3">á</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.6831%;margin-top:-5.7px;left:34.9775%;width:42px;">
      <p class="g-pstyle5">5<span class="g-cstyle18">0</span><span class="g-cstyle20">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.6831%;margin-top:-5.7px;left:85.2711%;width:63px;">
      <p class="g-pstyle5">2<span class="g-cstyle13">4</span><span class="g-cstyle7">,</span>9<span class="g-cstyle3">&ndash;</span>3<span class="g-cstyle18">0</span><span class="g-cstyle3">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.5687%;margin-top:-5.1px;left:4.0671%;width:31px;">
      <p class="g-pstyle7">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.5687%;margin-top:-5.1px;left:51.7272%;width:46px;">
      <p class="g-pstyle7">24<span class="g-cstyle2">-</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2377%;margin-top:-6.6px;left:7.7258%;width:132px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3"> </span><span class="g-cstyle9">V</span>alpa<span class="g-cstyle3">r</span>aís<span class="g-cstyle3">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.2377%;margin-top:-6.6px;left:56.2105%;width:121px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">A</span>rtu<span class="g-cstyle4">r</span>o P<span class="g-cstyle3">r</span><span class="g-cstyle5">a</span>t<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.4423%;margin-top:-5.7px;left:35.0399%;width:41px;">
      <p class="g-pstyle12"><span class="g-cstyle3">4</span>7<span class="g-cstyle20">,</span><span class="g-cstyle8">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.4423%;margin-top:-5.7px;left:85.3259%;width:62px;">
      <p class="g-pstyle13"><span class="g-cstyle3">1</span>4,<span class="g-cstyle8">6&ndash;</span><span class="g-cstyle3">2</span>4<span class="g-cstyle11">,</span><span class="g-cstyle8">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.3278%;margin-top:-5.1px;left:4.0438%;width:32px;">
      <p class="g-pstyle7">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.3278%;margin-top:-5.1px;left:51.7195%;width:46px;">
      <p class="g-pstyle7">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.9968%;margin-top:-6.6px;left:7.7258%;width:133px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">Ad</span>ol<span class="g-cstyle3">f</span>o Ibáñ<span class="g-cstyle3">ez</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:82.9968%;margin-top:-6.6px;left:56.2105%;width:155px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">B</span>e<span class="g-cstyle3">r</span>n<span class="g-cstyle3">a</span>r<span class="g-cstyle3">d</span>o <span class="g-cstyle3">O</span>&rsquo;<span class="g-cstyle3">H</span>iggin<span class="g-cstyle3">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.2014%;margin-top:-5.7px;left:34.9066%;width:42px;">
      <p class="g-pstyle5"><span class="g-cstyle3">4</span>6<span class="g-cstyle3">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.2014%;margin-top:-5.7px;left:85.3259%;width:62px;">
      <p class="g-pstyle13"><span class="g-cstyle3">1</span>4,<span class="g-cstyle8">6&ndash;</span><span class="g-cstyle3">2</span>4<span class="g-cstyle11">,</span><span class="g-cstyle8">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.2615%;margin-top:-5.1px;left:4.0515%;width:32px;">
      <p class="g-pstyle7">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:83.2615%;margin-top:-5.1px;left:51.7195%;width:46px;">
      <p class="g-pstyle7">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:88.756%;margin-top:-6.6px;left:7.7258%;width:130px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span>niv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">dad</span> <span class="g-cstyle3">d</span>e<span class="g-cstyle3">l</span> De<span class="g-cstyle3">sa</span>r<span class="g-cstyle4">r</span>oll<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai0-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:88.756%;margin-top:-6.6px;left:56.2105%;width:123px;">
      <p class="g-pstyle4"><span class="g-cstyle5">U</span><span class="g-cstyle3">n</span>iv<span class="g-cstyle3">e</span>r<span class="g-cstyle3">s</span>i<span class="g-cstyle3">d</span>a<span class="g-cstyle3">d</span> <span class="g-cstyle3">F</span>in<span class="g-cstyle3">i</span>s <span class="g-cstyle15">T</span><span class="g-cstyle3">e</span>r<span class="g-cstyle3">r</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.1351%;margin-top:-5.7px;left:34.9539%;width:40px;">
      <p class="g-pstyle8">4<span class="g-cstyle8">6</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai0-91" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.1351%;margin-top:-5.7px;left:85.3259%;width:62px;">
      <p class="g-pstyle13"><span class="g-cstyle3">1</span>4,<span class="g-cstyle8">6&ndash;</span><span class="g-cstyle3">2</span>4<span class="g-cstyle11">,</span><span class="g-cstyle8">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-92" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.0207%;margin-top:-5.1px;left:4.0283%;width:30px;">
      <p class="g-pstyle6"><span class="g-cstyle0">1</span>4</p>
    </div>
    <div id="g-ai0-93" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:89.0207%;margin-top:-5.1px;left:51.7195%;width:46px;">
      <p class="g-pstyle7">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai0-94" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:94.7468%;margin-top:-6.9px;left:1.4599%;width:216px;">
      <p class="g-pstyle14">(<span class="g-cstyle3">*</span>) <span class="g-cstyle10">F</span>u<span class="g-cstyle3">e</span>n<span class="g-cstyle3">t</span>e: <span class="g-cstyle3">w</span>w<span class="g-cstyle17">w</span><span class="g-cstyle14">.</span>t<span class="g-cstyle3">i</span>mesh<span class="g-cstyle3">i</span>gh<span class="g-cstyle3">e</span><span class="g-cstyle5">r</span>e<span class="g-cstyle3">d</span>uc<span class="g-cstyle4">a</span>tio<span class="g-cstyle3">n</span>.<span class="g-cstyle3">co</span><span class="g-cstyle1">m</span></p>
    </div>
  </div>

  <!-- Artboard: mobile -->
  <div id="g-09-the-latam-chile-mobile" class="g-artboard" style="max-width: 320px;max-height: 1164px" data-aspect-ratio="0.275" data-min-width="0" data-max-width="799">
<div style="padding: 0 0 363.75% 0;"></div>
    <img id="g-09-the-latam-chile-mobile-img" class="g-aiImg" alt="" src="${img1}"/>
    <div id="g-ai1-1" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:3.2672%;margin-top:-25px;left:1.7355%;width:291px;">
      <p class="g-pstyle0"><span class="g-cstyle0">THE</span> LATI<span class="g-cstyle0">N</span> AM<span class="g-cstyle0">E</span>RICA </p>
      <p class="g-pstyle0">U<span class="g-cstyle0">N</span>IV<span class="g-cstyle0">E</span>RSI<span class="g-cstyle0">TY</span> RA<span class="g-cstyle0">N</span>KI<span class="g-cstyle0">N</span>GS 202<span class="g-cstyle1">1</span></p>
    </div>
    <div id="g-ai1-2" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.8203%;margin-top:-7.4px;left:11.9922%;width:76px;">
      <p class="g-pstyle1"><span class="g-cstyle2">I</span>ns<span class="g-cstyle2">t</span>i<span class="g-cstyle2">t</span>u<span class="g-cstyle2">c</span>ió<span class="g-cstyle1">n</span></p>
    </div>
    <div id="g-ai1-3" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.8452%;margin-top:-6.7px;left:4.7267%;width:37px;">
      <p class="g-pstyle2">RK<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-4" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:6.8452%;margin-top:-6.7px;left:75.6068%;width:60px;">
      <p class="g-pstyle3">Puntaje </p>
    </div>
    <div id="g-ai1-5" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:7.6184%;margin-top:-6.7px;left:3.4732%;width:43px;">
      <p class="g-pstyle2"><span class="g-cstyle0">N</span>A<span class="g-cstyle1">C</span></p>
    </div>
    <div id="g-ai1-6" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.0541%;margin-top:-13px;left:11.971%;width:121px;">
      <p class="g-pstyle4"><span class="g-cstyle3">P</span>o<span class="g-cstyle3">nti</span>fi<span class="g-cstyle3">c</span>ia<span class="g-cstyle3"> </span><span class="g-cstyle4">U</span><span class="g-cstyle3">ni</span>ve<span class="g-cstyle3">r</span>sid<span class="g-cstyle3">a</span>d<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle5">C<span class="g-cstyle4">a</span>tól<span class="g-cstyle5">ica</span> <span class="g-cstyle5">d</span>e Ch<span class="g-cstyle5">i</span>l<span class="g-cstyle5">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-7" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1957%;margin-top:-6.7px;left:65.4039%;width:44px;">
      <p class="g-pstyle6">9<span class="g-cstyle6">0</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-8" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:10.1348%;margin-top:-6px;left:6.151%;width:28px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span> </p>
    </div>
    <div id="g-ai1-9" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.1472%;margin-top:-7px;left:11.971%;width:117px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>Ch<span class="g-cstyle5">i</span>le<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-10" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.2885%;margin-top:-6.7px;left:65.5727%;width:42px;">
      <p class="g-pstyle6">8<span class="g-cstyle5">2</span>,1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-11" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:13.2275%;margin-top:-6px;left:6.0878%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">2</span> </p>
    </div>
    <div id="g-ai1-12" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.0679%;margin-top:-13px;left:11.971%;width:124px;">
      <p class="g-pstyle4"><span class="g-cstyle3">P</span>o<span class="g-cstyle3">nti</span>fi<span class="g-cstyle3">c</span>ia<span class="g-cstyle3"> </span><span class="g-cstyle4">U</span><span class="g-cstyle3">ni</span>ve<span class="g-cstyle3">r</span>sid<span class="g-cstyle3">a</span>d<span class="g-cstyle3"> </span></p>
      <p class="g-pstyle5">C<span class="g-cstyle4">a</span>tól<span class="g-cstyle5">ica</span> <span class="g-cstyle5">d</span>e <span class="g-cstyle7">V</span><span class="g-cstyle5">a</span>lpa<span class="g-cstyle5">r</span>a<span class="g-cstyle5">í</span>s<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-13" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3813%;margin-top:-6.7px;left:65.4445%;width:43px;">
      <p class="g-pstyle6">6<span class="g-cstyle5">5</span>,8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-14" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:16.3203%;margin-top:-6px;left:6.109%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">3</span> </p>
    </div>
    <div id="g-ai1-15" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.0747%;margin-top:-13px;left:11.971%;width:103px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span></p>
      <p class="g-pstyle5">S<span class="g-cstyle5">a</span>nt<span class="g-cstyle5">i</span>ago d<span class="g-cstyle5">e </span>Ch<span class="g-cstyle5">i</span>l<span class="g-cstyle5">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-16" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4741%;margin-top:-6.7px;left:65.5928%;width:43px;">
      <p class="g-pstyle6">6<span class="g-cstyle5">2</span><span class="g-cstyle8">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-17" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:19.4131%;margin-top:-6px;left:6.0458%;width:30px;">
      <p class="g-pstyle7"><span class="g-cstyle0">4</span> </p>
    </div>
    <div id="g-ai1-18" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.1675%;margin-top:-13px;left:11.971%;width:111px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">A</span>ust<span class="g-cstyle5">r</span>al </p>
      <p class="g-pstyle5"><span class="g-cstyle5">d</span>e Chil<span class="g-cstyle5">e</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-19" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.5669%;margin-top:-6.7px;left:65.4445%;width:43px;">
      <p class="g-pstyle6">5<span class="g-cstyle9">8</span><span class="g-cstyle5">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-20" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:22.5059%;margin-top:-6px;left:6.109%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">5</span> </p>
    </div>
    <div id="g-ai1-21" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.3462%;margin-top:-13px;left:11.971%;width:119px;">
      <p class="g-pstyle4"><span class="g-cstyle4">U</span><span class="g-cstyle3">niv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>dad<span class="g-cstyle3"> </span><span class="g-cstyle10">T</span>éc<span class="g-cstyle3">n</span>i<span class="g-cstyle3">c</span>a</p>
      <p class="g-pstyle5"><span class="g-cstyle5">F</span>e<span class="g-cstyle5">d</span>e<span class="g-cstyle5">r</span>i<span class="g-cstyle5">c</span>o <span class="g-cstyle5">S</span>a<span class="g-cstyle5">n</span>ta M<span class="g-cstyle5">a</span>r<span class="g-cstyle5">í</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-22" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.6596%;margin-top:-6.7px;left:65.4881%;width:44px;">
      <p class="g-pstyle6">5<span class="g-cstyle11">4</span>,3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-23" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:25.5987%;margin-top:-6px;left:6.067%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">6</span> </p>
    </div>
    <div id="g-ai1-24" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.6111%;margin-top:-7px;left:11.971%;width:141px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>L<span class="g-cstyle5">o</span>s A<span class="g-cstyle5">n</span>d<span class="g-cstyle5">es</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-25" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.7524%;margin-top:-6.7px;left:65.3398%;width:43px;">
      <p class="g-pstyle8"><span class="g-cstyle3">5</span>4,<span class="g-cstyle3">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-26" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:28.6915%;margin-top:-6px;left:6.1301%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">7</span> </p>
    </div>
    <div id="g-ai1-27" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.7039%;margin-top:-7px;left:11.971%;width:165px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">A</span>utón<span class="g-cstyle5">o</span>m<span class="g-cstyle5">a</span> <span class="g-cstyle5">d</span>e <span class="g-cstyle5">Ch</span>ile<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-28" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.8452%;margin-top:-6.7px;left:65.424%;width:43px;">
      <p class="g-pstyle9"><span class="g-cstyle3">5</span>2<span class="g-cstyle3">,</span>4<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-29" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:31.7842%;margin-top:-6px;left:6.067%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">8</span> </p>
    </div>
    <div id="g-ai1-30" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.7967%;margin-top:-7px;left:11.971%;width:148px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>Co<span class="g-cstyle5">n</span>c<span class="g-cstyle5">e</span>p<span class="g-cstyle5">c</span>ió<span class="g-cstyle5">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-31" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.938%;margin-top:-6.7px;left:65.6569%;width:42px;">
      <p class="g-pstyle6">51<span class="g-cstyle11">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-32" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:34.877%;margin-top:-6px;left:6.067%;width:29px;">
      <p class="g-pstyle7"><span class="g-cstyle0">9</span> </p>
    </div>
    <div id="g-ai1-33" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.8895%;margin-top:-7px;left:11.971%;width:145px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">D</span>iego P<span class="g-cstyle5">o</span>rt<span class="g-cstyle5">a</span>les<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-34" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:38.0308%;margin-top:-6.7px;left:65.5492%;width:42px;">
      <p class="g-pstyle6">51,<span class="g-cstyle5">4</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-35" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:37.9698%;margin-top:-6px;left:5.3453%;width:33px;">
      <p class="g-pstyle10">10<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-36" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:40.9823%;margin-top:-7px;left:11.971%;width:145px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>La <span class="g-cstyle12">F</span><span class="g-cstyle4">r</span>ont<span class="g-cstyle5">e</span>r<span class="g-cstyle5">a</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-37" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.1236%;margin-top:-6.7px;left:65.4414%;width:43px;">
      <p class="g-pstyle6">5<span class="g-cstyle13">0</span><span class="g-cstyle14">,</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-38" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:41.0626%;margin-top:-6px;left:5.4503%;width:32px;">
      <p class="g-pstyle10">11<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-39" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:44.075%;margin-top:-7px;left:11.971%;width:141px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span><span class="g-cstyle7">V</span>alpa<span class="g-cstyle5">r</span>aís<span class="g-cstyle5">o</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-40" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:44.2163%;margin-top:-6.7px;left:65.6102%;width:43px;">
      <p class="g-pstyle11"><span class="g-cstyle5">4</span>7<span class="g-cstyle14">,</span><span class="g-cstyle3">9</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-41" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:44.1554%;margin-top:-6px;left:5.3873%;width:33px;">
      <p class="g-pstyle10">12<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-42" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.1678%;margin-top:-7px;left:11.971%;width:142px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">Ad</span>ol<span class="g-cstyle5">f</span>o Ibáñ<span class="g-cstyle5">ez</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-43" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.3091%;margin-top:-6.7px;left:65.2495%;width:44px;">
      <p class="g-pstyle6"><span class="g-cstyle5">4</span>6<span class="g-cstyle5">,</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-44" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:47.2482%;margin-top:-6px;left:5.408%;width:33px;">
      <p class="g-pstyle10">13<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-45" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.2606%;margin-top:-7px;left:11.971%;width:139px;">
      <p class="g-pstyle5"><span class="g-cstyle4">U</span>niv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">dad</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5">l</span> De<span class="g-cstyle5">sa</span>r<span class="g-cstyle4">r</span>oll<span class="g-cstyle1">o</span></p>
    </div>
    <div id="g-ai1-46" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.4019%;margin-top:-6.7px;left:65.3777%;width:41px;">
      <p class="g-pstyle9">4<span class="g-cstyle3">6</span>,<span class="g-cstyle1">5</span></p>
    </div>
    <div id="g-ai1-47" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:50.3409%;margin-top:-6px;left:5.3453%;width:31px;">
      <p class="g-pstyle7"><span class="g-cstyle0">1</span>4</p>
    </div>
    <div id="g-ai1-48" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.0957%;margin-top:-7px;left:11.9298%;width:118px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span><span class="g-cstyle16">T</span>al<span class="g-cstyle5">c</span>a<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-49" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.237%;margin-top:-6.7px;left:64.8126%;width:44px;">
      <p class="g-pstyle6">46,<span class="g-cstyle5">2</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-50" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:53.176%;margin-top:-6px;left:5.3656%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>5<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-51" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.0163%;margin-top:-13px;left:11.9298%;width:134px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">C</span><span class="g-cstyle15">a</span>tól<span class="g-cstyle5">i</span>c<span class="g-cstyle5">a</span> <span class="g-cstyle5">d</span>e </p>
      <p class="g-pstyle5">l<span class="g-cstyle5">a</span> S<span class="g-cstyle5">an</span>tísim<span class="g-cstyle5">a</span> C<span class="g-cstyle5">o</span>n<span class="g-cstyle5">ce</span>p<span class="g-cstyle5">c</span>ió<span class="g-cstyle5">n</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-52" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.3297%;margin-top:-6.7px;left:65.0046%;width:42px;">
      <p class="g-pstyle9"><span class="g-cstyle3">4</span>2,<span class="g-cstyle3">1</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-53" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:56.2688%;margin-top:-6px;left:5.3238%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-54" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.2812%;margin-top:-7px;left:11.9298%;width:160px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">C</span><span class="g-cstyle15">a</span>tól<span class="g-cstyle5">i</span>c<span class="g-cstyle5">a</span> <span class="g-cstyle5">d</span>el No<span class="g-cstyle5">rt</span>e<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-55" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.4225%;margin-top:-6.7px;left:65.1123%;width:43px;">
      <p class="g-pstyle6">3<span class="g-cstyle9">8</span><span class="g-cstyle17">,</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-56" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:59.3616%;margin-top:-6px;left:5.4077%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>7<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-57" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.374%;margin-top:-7px;left:11.9298%;width:140px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>L<span class="g-cstyle5">o</span>s Lagos<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-58" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.5153%;margin-top:-6.7px;left:64.9435%;width:44px;">
      <p class="g-pstyle6">3<span class="g-cstyle9">8</span><span class="g-cstyle11">,</span>6<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-59" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:62.4543%;margin-top:-6px;left:5.3238%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>8<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-60" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.4668%;margin-top:-7px;left:11.9298%;width:139px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span>La Se<span class="g-cstyle4">r</span>ena<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-61" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.6081%;margin-top:-6.7px;left:64.8792%;width:44px;">
      <p class="g-pstyle12"><span class="g-cstyle3">3</span>8<span class="g-cstyle18">,</span><span class="g-cstyle5">0</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-62" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:65.5471%;margin-top:-6px;left:5.3238%;width:33px;">
      <p class="g-pstyle10"><span class="g-cstyle2">1</span>9<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-63" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.5596%;margin-top:-7px;left:11.9298%;width:136px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">A</span>n<span class="g-cstyle5">d</span><span class="g-cstyle15">r</span><span class="g-cstyle5">é</span>s Bello<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-64" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.7009%;margin-top:-6.7px;left:57.7368%;width:63px;">
      <p class="g-pstyle9"><span class="g-cstyle3">3</span>1<span class="g-cstyle18">,</span>0&ndash;<span class="g-cstyle3">3</span><span class="g-cstyle19">7</span><span class="g-cstyle3">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-65" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:68.6399%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-66" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.6524%;margin-top:-7px;left:11.9298%;width:109px;">
      <p class="g-pstyle4"><span class="g-cstyle15">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d<span class="g-cstyle3"> </span>M<span class="g-cstyle3">ay</span>or<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-67" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.7937%;margin-top:-6.7px;left:57.7368%;width:63px;">
      <p class="g-pstyle9"><span class="g-cstyle3">3</span>1<span class="g-cstyle18">,</span>0&ndash;<span class="g-cstyle3">3</span><span class="g-cstyle19">7</span><span class="g-cstyle3">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-68" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:71.7327%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-69" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.7451%;margin-top:-7px;left:11.9298%;width:136px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5"> </span><span class="g-cstyle16">T</span>a<span class="g-cstyle5">r</span>ap<span class="g-cstyle5">a</span>cá<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-70" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.8864%;margin-top:-6.7px;left:57.7368%;width:63px;">
      <p class="g-pstyle9"><span class="g-cstyle3">3</span>1<span class="g-cstyle18">,</span>0&ndash;<span class="g-cstyle3">3</span><span class="g-cstyle19">7</span><span class="g-cstyle3">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-71" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:74.8255%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-72" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.7517%;margin-top:-13px;left:11.9298%;width:116px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">C</span><span class="g-cstyle15">a</span>tól<span class="g-cstyle5">i</span>c<span class="g-cstyle5">a</span> </p>
      <p class="g-pstyle5"><span class="g-cstyle5">d</span>e <span class="g-cstyle10">T</span>emu<span class="g-cstyle5">co</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-73" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9792%;margin-top:-6.7px;left:57.7368%;width:63px;">
      <p class="g-pstyle9"><span class="g-cstyle3">3</span>1<span class="g-cstyle18">,</span>0&ndash;<span class="g-cstyle3">3</span><span class="g-cstyle19">7</span><span class="g-cstyle3">,</span>1<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-74" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:77.9183%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">20<span class="g-cstyle2">-</span>23<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-75" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:80.9307%;margin-top:-7px;left:11.9298%;width:129px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">d</span>e<span class="g-cstyle5">l</span> Bí<span class="g-cstyle5">o</span><span class="g-cstyle20">-</span>Bío<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-76" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:81.072%;margin-top:-6.7px;left:57.0996%;width:67px;">
      <p class="g-pstyle6">2<span class="g-cstyle11">4</span><span class="g-cstyle6">,</span>9<span class="g-cstyle5">&ndash;</span>3<span class="g-cstyle13">0</span><span class="g-cstyle5">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-77" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:81.011%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">24<span class="g-cstyle2">-</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-78" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.0235%;margin-top:-7px;left:11.9298%;width:144px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> S<span class="g-cstyle5">a</span>n Sebasti<span class="g-cstyle5">á</span>n<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-79" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.1648%;margin-top:-6.7px;left:57.0996%;width:67px;">
      <p class="g-pstyle6">2<span class="g-cstyle11">4</span><span class="g-cstyle6">,</span>9<span class="g-cstyle5">&ndash;</span>3<span class="g-cstyle13">0</span><span class="g-cstyle5">,</span>3<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-80" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:84.1038%;margin-top:-6px;left:3.1769%;width:48px;">
      <p class="g-pstyle10">24<span class="g-cstyle2">-</span>25<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-81" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.1163%;margin-top:-7px;left:11.9298%;width:129px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">A</span>rtu<span class="g-cstyle4">r</span>o P<span class="g-cstyle5">r</span><span class="g-cstyle15">a</span>t<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-82" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.2576%;margin-top:-6.7px;left:57.2479%;width:65px;">
      <p class="g-pstyle13"><span class="g-cstyle5">1</span>4,<span class="g-cstyle3">6&ndash;</span><span class="g-cstyle5">2</span>4<span class="g-cstyle17">,</span><span class="g-cstyle3">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-83" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:87.1966%;margin-top:-6px;left:3.1558%;width:48px;">
      <p class="g-pstyle10">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-84" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:90.0369%;margin-top:-13px;left:11.9298%;width:111px;">
      <p class="g-pstyle4"><span class="g-cstyle15">U</span>n<span class="g-cstyle3">iv</span>e<span class="g-cstyle3">r</span>s<span class="g-cstyle3">i</span>d<span class="g-cstyle3">a</span>d</p>
      <p class="g-pstyle5"><span class="g-cstyle5">B</span>e<span class="g-cstyle5">r</span>n<span class="g-cstyle5">a</span>r<span class="g-cstyle5">d</span>o <span class="g-cstyle5">O</span>&rsquo;<span class="g-cstyle5">H</span>iggin<span class="g-cstyle5">s</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-85" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:90.3504%;margin-top:-6.7px;left:57.2479%;width:65px;">
      <p class="g-pstyle13"><span class="g-cstyle5">1</span>4,<span class="g-cstyle3">6&ndash;</span><span class="g-cstyle5">2</span>4<span class="g-cstyle17">,</span><span class="g-cstyle3">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-86" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:90.2894%;margin-top:-6px;left:3.1558%;width:48px;">
      <p class="g-pstyle10">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-87" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.3018%;margin-top:-7px;left:11.9298%;width:132px;">
      <p class="g-pstyle5"><span class="g-cstyle15">U</span><span class="g-cstyle5">n</span>iv<span class="g-cstyle5">e</span>r<span class="g-cstyle5">s</span>i<span class="g-cstyle5">d</span>a<span class="g-cstyle5">d</span> <span class="g-cstyle5">F</span>in<span class="g-cstyle5">i</span>s <span class="g-cstyle10">T</span><span class="g-cstyle5">e</span>r<span class="g-cstyle5">r</span>ae<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-88" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.4431%;margin-top:-6.7px;left:57.2479%;width:65px;">
      <p class="g-pstyle13"><span class="g-cstyle5">1</span>4,<span class="g-cstyle3">6&ndash;</span><span class="g-cstyle5">2</span>4<span class="g-cstyle17">,</span><span class="g-cstyle3">7</span><span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-89" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:93.3822%;margin-top:-6px;left:3.1558%;width:48px;">
      <p class="g-pstyle10">26<span class="g-cstyle2">-</span>28<span class="g-cstyle1"> </span></p>
    </div>
    <div id="g-ai1-90" class="g-ai2html-settings g-aiAbs g-aiPointText" style="top:96.8127%;margin-top:-6.9px;left:3.3372%;width:216px;">
      <p class="g-pstyle5">(<span class="g-cstyle5">*</span>) <span class="g-cstyle9">F</span>u<span class="g-cstyle5">e</span>n<span class="g-cstyle5">t</span>e: <span class="g-cstyle5">w</span>w<span class="g-cstyle20">w</span><span class="g-cstyle18">.</span>t<span class="g-cstyle5">i</span>mesh<span class="g-cstyle5">i</span>gh<span class="g-cstyle5">e</span><span class="g-cstyle15">r</span>e<span class="g-cstyle5">d</span>uc<span class="g-cstyle4">a</span>tio<span class="g-cstyle5">n</span>.<span class="g-cstyle5">co</span><span class="g-cstyle1">m</span></p>
    </div>
  </div>


</div>
`

const containerId = 'g-09-the-latam-chile-box'
const namespace = 'g-'
const name = '09-the-latam-chile'

export default makeAi2React({ html, styles, containerId, namespace, name })

/* End ai2react - 2021-09-14 04:14 */
